var exports = {
  "A": "xcc377c0b--2a0c28--item",
  "D": "xcc377c0b--2a0c28--title",
};

module.exports = exports;
